import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const SpotifyIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="Frame 1000005797">
        <g id="Group">
          <path
            id="Exclude"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.5384 10.1538C20.5384 15.7617 15.9924 20.3077 10.3846 20.3077C4.77674 20.3077 0.230713 15.7617 0.230713 10.1538C0.230713 4.54603 4.77674 0 10.3846 0C15.9924 0 20.5384 4.54603 20.5384 10.1538ZM4.54729 7.84754C8.31458 6.84293 12.7708 7.10286 16.4447 9.03912C16.9098 9.28423 17.4856 9.10591 17.7307 8.64081C17.9758 8.17572 17.7975 7.59998 17.3324 7.35486C13.1794 5.16612 8.22214 4.8972 4.05674 6.00798C3.54876 6.14344 3.24677 6.66505 3.38223 7.17303C3.51769 7.68101 4.03931 7.983 4.54729 7.84754ZM15.1847 12.1705C12.3045 10.3643 8.16487 10.1436 5.10468 10.9964C4.66858 11.118 4.21653 10.863 4.095 10.4269C3.97346 9.99079 4.22846 9.53874 4.66456 9.41721C8.05629 8.47197 12.6955 8.67434 16.0557 10.7816C16.4392 11.0221 16.5552 11.528 16.3146 11.9116C16.0741 12.2951 15.5682 12.411 15.1847 12.1705ZM5.23375 13.8937C8.02826 13.2727 11.1112 13.0429 14.1843 14.8768C14.4853 15.0564 14.8749 14.958 15.0545 14.6571C15.2341 14.3561 15.1357 13.9665 14.8348 13.7869C11.3502 11.7074 7.87544 12.0064 4.95842 12.6547C4.61627 12.7307 4.40055 13.0697 4.47658 13.4118C4.55261 13.754 4.89161 13.9697 5.23375 13.8937Z"
            fill={fillColor || '#9D9DA6'}
          />
        </g>
      </g>
    </svg>
  );
};

export { SpotifyIcon };
